import { QualificationListDTO } from '../qualification/qualification-list.dto';

export class TradeRequestEventResourceListDTO {

    id: string;

    name: string;

    description: string;

    qualifications: Array<QualificationListDTO>;

}